<template>
  <div class="main_top">
    <ChildComponent
      title="车辆出入园总数"
      :count="(data?.car || 0) + ' 辆'"
    ></ChildComponent>
    <ChildComponent
      title="人员出入园总数"
      :count="(data?.person || 0) + ' 名'"
    ></ChildComponent>
    <ChildComponent
      title="设备告警数"
      :count="(data?.alarm || 0) + ' 次'"
    ></ChildComponent>
    <ChildComponent
      title="预约总数"
      :count="(data?.application || 0) + ' 个'"
    ></ChildComponent>
  </div>
</template>

<script setup>
  import {
    ref,
    defineComponent,
    onMounted,
    onUnmounted,
    defineExpose,
  } from 'vue'
  import { getTodayOther } from '@/api/dashboard'

  const data = ref()
  const timer = ref()
  async function fetch() {
    const res = await getTodayOther()
    if (res.success) {
      data.value = res.data
    }
  }
  onMounted(() => {
    fetch()
    timer.value = setInterval(fetch, 60 * 1000)
  })
  onUnmounted(() => clearInterval(timer.value))

  // 定义子组件
  const ChildComponent = defineComponent({
    props: {
      title: {
        type: String,
        required: true,
      },
      count: {
        type: Object,
        required: true,
      },
    },
    template: `
      <div class='item'>
        <div class="gray_text">{{ title }}</div>
        <div>
          <span class="number artistic_font_numbers">{{count||0}}</span>
        </div>
      </div>
    `,
  })
</script>

<style lang="less" scoped>
  .main_top {
    display: flex;
    justify-content: space-around;

    /deep/ .item {
      flex: 1;
      text-align: center;
    }
    /deep/ .number {
      color: #65eafc;
    }
    /deep/ .gray_text {
      margin-bottom: 5px;
      color: #ffffff8c;
      font-size: 13px;
    }
  }
</style>
